import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { GeoLocation, getCoords, setIsInside } from '../Store'
import { venueData } from '../Utils/venueData'
import { ClosestVenue, findClosestVenue } from '../Utils/geoFenceUtils'
import {
  validateCoordinates,
  ValidateCoordinatesEnum,
} from '@core/Areas/VenueMode/Utils/validateCoordinates'

export interface LocationDetail {
  geoLocation?: GeoLocation
  closestVenue?: ClosestVenue
  error?: string
  delta?: number
}

export const useVenueProximity = (isEnabled = true) => {
  const [locationDetail, setLocationDetail] = useState<LocationDetail>({})
  const dispatch = useDispatch()
  const geoLocation = useSelector(getCoords)

  useEffect(() => {
    if (!isEnabled) return
    const validationResult = validateCoordinates(geoLocation)
    if (validationResult != ValidateCoordinatesEnum.Success) {
      setLocationDetail({ geoLocation, error: `${validationResult}` })
      dispatch(setIsInside(false))
      return
    }

    const closestVenue = findClosestVenue(geoLocation, venueData)
    const isInsideVenue = !!closestVenue && closestVenue.inside
    setLocationDetail({ geoLocation, closestVenue })
    dispatch(setIsInside(isInsideVenue))
  }, [geoLocation, dispatch, isEnabled])

  return { locationDetail }
}
